import type { ErrorComponentProps } from '@tanstack/react-router'

export type ErrorFallbackModelProps = ErrorComponentProps

const HEADLINE = 'Algo saiu do lugar.'
const MESSAGE = 'Nossas flores se embaraçaram por um instante. Tente novamente.'
const HOME_HREF = '/'
const HOME_LABEL = 'Voltar ao início'

export function useErrorFallbackModel(_props: ErrorFallbackModelProps) {
  return {
    headline: HEADLINE,
    message: MESSAGE,
    homeHref: HOME_HREF,
    homeLabel: HOME_LABEL,
  }
}
